const BEST_SCORE_KEY = "suika-phaser-best-score";

export const loadBestScore = (): number => {
  try {
    const stored = window.localStorage.getItem(BEST_SCORE_KEY);
    return stored ? Number.parseInt(stored, 10) || 0 : 0;
  } catch {
    return 0;
  }
};

export const saveBestScore = (score: number): void => {
  try {
    window.localStorage.setItem(BEST_SCORE_KEY, `${score}`);
  } catch {
    // Storage can be unavailable in private browsing contexts.
  }
};
